module.exports = __webpack_public_path__ + "img/teehuay2.b9bb3134.png";